import { useEffect, useRef } from "react";

/**
 * Shared hash magic-link login attempt: run reCAPTCHA once, dispatch verifyOtpHash,
 * redirect on reCAPTCHA or verify failure (toast should be shown by caller / saga).
 */
export function useLoginOtpHashLogin({
  hash,
  fromRegister = false,
  userData,
  verifyLoading,
  verifyOtpHash,
  runRecaptcha,
  onRecaptchaFailure,
  onVerifyFailure
}) {
  const hashAttemptStartedRef = useRef(false);
  const hashVerifyDispatchedRef = useRef(false);
  const prevVerifyLoadingRef = useRef(false);

  useEffect(() => {
    if (userData || !hash || hashAttemptStartedRef.current) {
      return;
    }

    hashAttemptStartedRef.current = true;

    const attemptHashLogin = async () => {
      const recaptcha = await runRecaptcha();

      if (!recaptcha) {
        onRecaptchaFailure();
        return;
      }

      hashVerifyDispatchedRef.current = true;
      verifyOtpHash({
        hash,
        recaptcha,
        fromRegister
      });
    };

    attemptHashLogin();
  }, [
    hash,
    fromRegister,
    userData,
    verifyOtpHash,
    runRecaptcha,
    onRecaptchaFailure
  ]);

  useEffect(() => {
    const wasLoading = prevVerifyLoadingRef.current;
    prevVerifyLoadingRef.current = verifyLoading;

    if (
      !hashVerifyDispatchedRef.current ||
      !wasLoading ||
      verifyLoading ||
      userData
    ) {
      return;
    }

    onVerifyFailure();
  }, [verifyLoading, userData, onVerifyFailure]);
}
